const QUERY_KEYS = {
    Asset: 'getAsset',
    Shipments: 'getReadyToShip',
}

export default QUERY_KEYS
